'use client'

import {PifflBox} from '@/types/box/PifflBox'
import dynamic from 'next/dynamic'

const PublicSectorMap = dynamic(
  () => import('@/app/[locale]/partner/aktivitetsboxar-offentliga-rum/PublicSectorMap').then((mod) => mod.PublicSectorMap),
  {ssr: false},
)

interface Props {
  boxes: PifflBox[]
  center?: [number, number]
  defaultZoom?: number
}

export const PublicSectorMapWrapper: React.FC<Props> = ({boxes, center, defaultZoom}) => (
  <div className="h-[min(70vh,560px)] w-full overflow-hidden rounded-lg shadow-sm">
    <PublicSectorMap boxes={boxes} center={center} defaultZoom={defaultZoom} />
  </div>
)
